import {Component} from 'react';
import PropTypes from 'prop-types';
import SharePopoverPanel from '../SharePopoverPanel';
import CopyableFormControl from '../CopyableFormControl';

export default class LinkSection extends Component {
	componentDidMount() {
		const {linkObj, proxiedAs} = this.props;
		const isSameUser = proxiedAs && linkObj ? linkObj.advisorId === proxiedAs.userID : true ;

		if (!linkObj || !isSameUser) {
			this.props.getLink();
		}
	}

	render() {
		const {linkObj, expanded, expandSection, mediaTypeName} = this.props;

		if (!linkObj) {
			return null;
		}

		return (
			<SharePopoverPanel title="Get a link to share" expanded={expanded} onClick={expandSection}>
				<form>
					<div className="form-group">
						<span className="small">
							{`Copy the link below to share this ${mediaTypeName} with clients or prospects.`}
						</span>
					</div>
					<CopyableFormControl value={linkObj.link} />
				</form>
			</SharePopoverPanel>
		);
	}
}

LinkSection.propTypes = {
	mediaTypeName: PropTypes.string,
	expanded: PropTypes.bool,
	linkObj: PropTypes.shape({
		link: PropTypes.string,
		id: PropTypes.number,
		version: PropTypes.number
	}),
	getLink: PropTypes.func.isRequired,
	expandSection: PropTypes.func.isRequired
};
LinkSection.defaultProps = {
	expanded: false
};